import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { CTA_LABEL } from "@/config/site";

const NAV_LINKS = [
  { label: "Outbound Engine Build", path: "/outbound-engine-build", testId: "nav-outbound-engine-build" },
  { label: "Custom Workflows", path: "/custom-workflows", testId: "nav-custom-workflows" },
  { label: "Industries", path: "/industries", testId: "nav-industries" },
  { label: "Workflow Library", path: "/workflows", testId: "nav-workflow-library" },
  { label: "Insights", path: "/insights", testId: "nav-insights" },
];

export default function Navigation({ mobileMenuOpen, setMobileMenuOpen }) {
  const { pathname } = useLocation();

  return (
    <>
      <nav className="sticky top-0 z-40 bg-[#F4E9D8]/95 backdrop-blur-md border-b border-[#1F1F1C]/10" data-testid="navigation">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-6">
          <Link to="/" className="font-fraunces font-extrabold text-lg sm:text-xl tracking-tight text-[#1F1F1C] shrink-0" data-testid="nav-logo">
            Raki Solutions<span className="text-[#C8703A]">.</span>
          </Link>

          <div className="hidden xl:flex items-center gap-7 text-sm font-medium">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className={`transition-colors ${pathname.startsWith(l.path) ? "text-[#C8703A]" : "text-[#4A463F] hover:text-[#1F1F1C]"}`}
                data-testid={l.testId}
              >
                {l.label}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/audit"
              className="btn-press hidden sm:inline-flex bg-[#C8703A] text-[#F4E9D8] px-5 py-2.5 rounded-2xl font-semibold text-sm hover:bg-[#B35F2C]"
              data-testid="nav-cta"
            >
              {CTA_LABEL}
            </Link>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="xl:hidden text-[#1F1F1C] p-1"
              aria-label="Toggle menu"
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="fixed top-[80px] left-4 right-4 z-40 xl:hidden bg-[#EADCC6] rounded-2xl border border-[#1F1F1C]/15 p-5" data-testid="mobile-menu">
          <div className="flex flex-col">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                onClick={() => setMobileMenuOpen(false)}
                className="py-3 text-[#1F1F1C] font-medium border-b border-[#1F1F1C]/10 last:border-0"
                data-testid={`mobile-${l.testId}`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/audit"
              onClick={() => setMobileMenuOpen(false)}
              className="mt-4 bg-[#C8703A] text-[#F4E9D8] py-3.5 px-6 rounded-2xl font-semibold text-center text-sm"
              data-testid="mobile-nav-cta"
            >
              {CTA_LABEL}
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
